module.exports = __webpack_public_path__ + "img/tiktok.93a17aeb.svg";